
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from '../pages/home';
import { Support } from '../pages/support'
import { UltimateCannabisAdventurePage } from '../pages/ultimateCannabisAdventurePage';
import { PrivacyPolicy } from '../pages/privacyPolicy';
import { UcaRulesPage } from '../pages/ucaRulesPage';
import { HowToPost } from '../pages/howToPost';
import { TermsOfService } from '../pages/termsOfService';
import { TermsOfServiceBudtenders } from "../pages/termsOfServiceBudtenders"

const Router = () => {
    // TODO: FIX THE NO MATCH WHEN URL IS NOT FOUND

    // useEffect(() => {
    //   console.log('the active business has been updated', business);
    // }, [business.activeBusiness])

    return (
        <BrowserRouter basename={'/'} >
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/support" element={<Support />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/terms-of-service-budtenders" element={<TermsOfServiceBudtenders />} />
                <Route path="/ultimate-cannabis-adventure/rules" element={<UcaRulesPage />} />
                <Route path="/ultimate-cannabis-adventure" element={<UltimateCannabisAdventurePage />} />
                <Route path="/tutorial/post" element={<HowToPost />} />
                {/* <Route path={`${process.env.PUBLIC_URL}/business`} element={BusinessHome} />

                <Route path={`${process.env.PUBLIC_URL}/sign-up`} element={SignUp} />
                <Route path={`${process.env.PUBLIC_URL}/forget-password`} element={ForgetPassword} />
                <Route path={`${process.env.PUBLIC_URL}/thank-you`} element={ThankYou} />
                <Route path={`${process.env.PUBLIC_URL}/review`} element={Review} />
                <Route path={`${process.env.PUBLIC_URL}/404`} element={PageNotFound} />
                <Route path={`${process.env.PUBLIC_URL}/faq`} element={Faq} />
                <Route path={`${process.env.PUBLIC_URL}/request`} element={Request} />
                <Route path={`${process.env.PUBLIC_URL}/download`} element={Download} />
                <Route path={`${process.env.PUBLIC_URL}/coming-soon`} element={ComingSoon} />
                <Route element={NoMatch} /> */}
            </Routes>
        </BrowserRouter>
    );
};

export { Router };
